(() => {
    /* COMPONENT MANAGER */
    class Components {
        constructor(container) {
            this.items      = {};
            this.MAIN_INSTANCE_NAME = 'Instance';
            /* Look for components and register them */
            this.register('component, .js-component', App.Component, 'Component');
            App.load(() => this.apply());
        }

        /* Register a component */
        register(selector, instance, name = this.MAIN_INSTANCE_NAME) {
            // avoid repeated instance
            if (!(selector in this.items)) {
                this.items[selector] = {
                    name:       name,
                    instance:   instance,
                };
            }
            this.applyBySelector(selector);
        }

        /**
         * Start non stated components to its selectors
         */
        apply() {
            for (let selector in this.items) {
                this.applyBySelector(selector);
            }
            return this;
        }

        /**
         * Start non stated components to its selectors
         */
        applyBySelector(selector) {
            this.waitForSelector(selector, item => {
                let name        = item['name'];
                let instance    = item['instance'];
                if (!instance) return;
                Array.prototype.slice.call(document.querySelectorAll(selector), 0).forEach((element) => {
                    if (!(element[name] instanceof instance)) element[name] = new instance(element);
                });
            });
            return this;
        }

        /**
         *
         * @param selectorOrElement CSS selector String or a node element
         * @param component
         * @param callback @deprecated
         * @param silenced
         * @return {Promise<unknown>}
         */
        wait(selectorOrElement, component = this.MAIN_INSTANCE_NAME, callback = null, silenced = false) {
            return new Promise((resolve, reject) => {
                const errorMessage = 'Could not load Component "' + component + '" for selector: ' + selectorOrElement;
                const element = typeof selectorOrElement === 'string' ?
                    document.querySelector(selectorOrElement) : selectorOrElement;
                if (element) {
                    const intervalId = App.setInterval(() => {
                        if (element[component] !== undefined) {
                            clearInterval(intervalId);
                            try {
                                resolve(element[component]);
                                if (callback) callback(element[component]);
                            } catch (e) {
                                if (!silenced) reject(errorMessage);
                                clearInterval(intervalId);
                            }
                        }
                    });
                    setTimeout(() => clearInterval(intervalId), 5000);
                } else {
                    if (!silenced) reject(errorMessage);
                }
            });
        }

        waitForSelector(selector, callback) {
            let interval = App.setInterval(() => {
                if (selector in this.items) {
                    clearInterval(interval);
                    try {
                        callback(this.items[selector]);
                    } catch (e) {
                        clearInterval(interval);
                        App.error(e);
                    }
                }
            });
            setTimeout(() => clearInterval(interval), 5000);
        }

        selector(name) {
            return '.component.' + name;
        }
    }
    App.Components = new Components();
})();
